/* eslint-disable import/prefer-default-export */
import axios from './axiosInstance';

export const getFeed = async (signal: AbortSignal) => {
    try {
        const response = await axios.get('/api/transactionFeed', { signal });
        if (response.status !== 200) return undefined;

        const { sections } = response.data;
        return sections;
    } catch (err) {
        return undefined;
    }
};
